import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSitemapLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M13 3C14.1046 3 15 3.89543 15 5V7C15 8.10457 14.1046 9 13 9V11H17C18.6569 11 20 12.3431 20 14V15C21.1046 15 22 15.8954 22 17V19C22 20.1046 21.1046 21 20 21H18C16.8954 21 16 20.1046 16 19V17C16 15.8954 16.8954 15 18 15V14C18 13.4477 17.5523 13 17 13H13V15C14.1046 15 15 15.8954 15 17V19C15 20.1046 14.1046 21 13 21H11C9.89543 21 9 20.1046 9 19V17C9 15.8954 9.89543 15 11 15V13H7C6.44772 13 6 13.4477 6 14V15C7.10457 15 8 15.8954 8 17V19C8 20.1046 7.10457 21 6 21H4C2.89543 21 2 20.1046 2 19V17C2 15.8954 2.89543 15 4 15V14C4 12.3431 5.34315 11 7 11H11V9C9.89543 9 9 8.10457 9 7V5C9 3.89543 9.89543 3 11 3H13ZM20 17H18V19H20V17ZM6 17H4V19H6V17ZM13 17H11V19H13V17ZM13 5H11V7H13V5Z"
	})
});
export default SvgSitemapLine;
